const OrderUnits = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];

export default function getFileSizeString(size) {

    let order = Math.floor(Math.log2(size)/10);
    order = Math.min(Math.max(0, order), OrderUnits.length-1);

    let orderMag = 1024**order;
    let sizeInUnits = size/orderMag;

    let sizeStr = sizeInUnits.toFixed(1);
    if (/\.0$/.test(sizeStr)) {
        sizeStr = sizeStr.substring(0, sizeStr.length-2);
    }

    return sizeStr+' '+OrderUnits[order];

}
